import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilServiceService {

  public mediaStream: any = null;

  constructor() { }

  checkAndCloseMedisStream() {
    if (this.mediaStream != null) {
      this.mediaStream.getTracks().forEach((tracks) => {
        tracks.stop();
      })
    }
  }


}
